import { useCallback } from "react";

import { useIntl } from "react-intl";

import EmailRecipientAddress from "@mapmycustomers/shared/types/email/EmailRecipientAddress";

import messages from "../components/messages";

import useIsCurrentUserEmail from "./useIsCurrentUserEmail";

const useGetEmailRecipientName = () => {
  const intl = useIntl();
  const isCurrentUserEmail = useIsCurrentUserEmail();

  return useCallback(
    (recipient: EmailRecipientAddress) => {
      if (isCurrentUserEmail(recipient.email)) {
        return intl.formatMessage(messages.meRecipient);
      }
      return recipient.name ?? recipient.email;
    },
    [intl, isCurrentUserEmail]
  );
};

export default useGetEmailRecipientName;
